import React from 'react';
import { ConfigurableEmailInfo } from 'types/emailService';
import { useNotificationSettingsPageStore } from 'store/pages/user-settings/notification-settings/pageStore';
import { Toggle } from '@insurancemenu/imenu-components-lib';
import { CardStyled, DescriptionStyled, EmailInfoStyled, TitleStyled, ToggleWrapperStyled } from './styles';

interface NotificationEmailCardProps {
  email: ConfigurableEmailInfo;
  isChecked: boolean;
}

const NotificationEmailCard = ({ email, isChecked }: NotificationEmailCardProps): JSX.Element => {
  const { updateEmailCheckStatus } = useNotificationSettingsPageStore();

  const updateEmailStatus = (): void => {
    updateEmailCheckStatus(email.name);
  };

  return (
    <CardStyled $isChecked={isChecked}>
      <EmailInfoStyled>
        <TitleStyled>{email.title}</TitleStyled>
        <DescriptionStyled>{email.description}</DescriptionStyled>
      </EmailInfoStyled>
      <ToggleWrapperStyled>
        <Toggle
          fixedLabelSide="right"
          labelActive="On"
          labelInactive="Off"
          checked={isChecked}
          onChange={updateEmailStatus}
        />
      </ToggleWrapperStyled>
    </CardStyled>
  );
};

export default NotificationEmailCard;
